module.exports = __webpack_public_path__ + "static/media/6.74b6e079.jpg";